// import { useCallback, useEffect, useState } from 'react';
// import axiosInstance from '../utils/axios';
// import { useSocket } from '../context/SocketContext';

// // 🔥 Customer (anonymous user) ke liye orders hook
// export const useMyOrders = () => {
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const { socket, isConnected } = useSocket();

//   // ---------------------------------------------
//   // FETCH MY ORDERS
//   // ---------------------------------------------
//   const fetchMyOrders = useCallback(async () => {
//     try {
//       setLoading(true);
//       const { data } = await axiosInstance.get('/my-orders');
//       setOrders(data.orders || []);
//       setError(null);
//     } catch (err) {
//       console.error('Fetch my orders failed:', err);
//       setError(err.response?.data?.message || 'Failed to load orders');
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchMyOrders();
//   }, [fetchMyOrders]);

//   // ---------------------------------------------
//   // REAL-TIME SOCKET UPDATES
//   // ---------------------------------------------
//   useEffect(() => {
//     if (!socket || !isConnected || orders.length === 0) return;

//     // Har order ke room me join karo (extra safety)
//     orders.forEach((o) => {
//       socket.emit('join-order', { orderId: o._id });
//     });

//     const upsertOrder = (data) => {
//       // Data kabhi direct order ho sakta hai, kabhi { order } wrapper me
//       const updated = data?.order || data;
//       if (!updated?._id) return;

//       setOrders((prev) => {
//         const exists = prev.find((o) => o._id === updated._id);
//         if (!exists) return [updated, ...prev];
//         return prev.map((o) => (o._id === updated._id ? updated : o));
//       });
//     };

//     const handleCancelled = (data) => {
//       const orderId = data?.orderId || data?.order?._id;
//       if (!orderId) return;

//       setOrders((prev) =>
//         prev.map((o) =>
//           o._id === orderId
//             ? { ...o, status: 'CANCELLED', ...(data?.order || {}) }
//             : o
//         )
//       );
//     };

//     socket.on('order-status-updated', upsertOrder);
//     socket.on('order-updated', upsertOrder);
//     socket.on('order-cancelled', handleCancelled);

//     return () => {
//       socket.off('order-status-updated', upsertOrder);
//       socket.off('order-updated', upsertOrder);
//       socket.off('order-cancelled', handleCancelled);

//       // Leave rooms
//       orders.forEach((o) => {
//         socket.emit('leave-order', { orderId: o._id });
//       });
//     };
//   }, [socket, isConnected, orders.length]);

//   // ---------------------------------------------
//   // UPDATE ORDER (only if PENDING)
//   // ---------------------------------------------
//   const updateMyOrder = async (orderId, payload) => {
//     try {
//       const { data } = await axiosInstance.put(`/my-orders/${orderId}`, payload);
//       // Local state update
//       setOrders((prev) =>
//         prev.map((o) => (o._id === orderId ? data.order : o))
//       );
//       return { success: true, order: data.order };
//     } catch (err) {
//       return {
//         success: false,
//         message: err.response?.data?.message || 'Update failed',
//       };
//     }
//   };

//   // ---------------------------------------------
//   // CANCEL ORDER (only if PENDING)
//   // ---------------------------------------------
//   const cancelMyOrder = async (orderId, reason = '') => {
//     try {
//       const { data } = await axiosInstance.delete(`/my-orders/${orderId}`, {
//         data: { reason },
//       });
//       setOrders((prev) =>
//         prev.map((o) => (o._id === orderId ? data.order : o))
//       );
//       return { success: true, order: data.order };
//     } catch (err) {
//       return {
//         success: false,
//         message: err.response?.data?.message || 'Cancel failed',
//       };
//     }
//   };

//   return {
//     orders,
//     loading,
//     error,
//     refetch: fetchMyOrders,
//     updateMyOrder,
//     cancelMyOrder,
//   };
// };

// import { useEffect, useCallback } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchMyOrders,
//   fetchMyOrderById,
//   updateMyOrder,
//   cancelMyOrder,
//   clearMyOrdersError,
//   clearMyOrdersSuccess,
//   clearCurrentMyOrder,
//   resetMyOrdersState,
//   socketOrderUpsert,
//   socketOrderCancelled,
// } from "../redux/slices/myOrdersSlice";
// import { useSocket } from "../context/SocketContext";

// export const useMyOrders = () => {
//   const dispatch = useDispatch();
//   const myOrdersState = useSelector((state) => state.myOrders);
//   const { socket, isConnected } = useSocket();

//   // Real-time socket listeners
//   useEffect(() => {
//     if (!socket || !isConnected) return;

//     const handleStatusUpdate = (data) => {
//       dispatch(socketOrderUpsert(data));
//     };

//     const handleOrderUpdated = (data) => {
//       dispatch(socketOrderUpsert(data));
//     };

//     const handleOrderCancelled = (data) => {
//       dispatch(socketOrderCancelled(data));
//     };

//     socket.on("order-status-updated", handleStatusUpdate);
//     socket.on("order-updated", handleOrderUpdated);
//     socket.on("order-cancelled", handleOrderCancelled);

//     return () => {
//       socket.off("order-status-updated", handleStatusUpdate);
//       socket.off("order-updated", handleOrderUpdated);
//       socket.off("order-cancelled", handleOrderCancelled);
//     };
//   }, [socket, isConnected, dispatch]);

//   // Join order rooms for real-time updates
//   useEffect(() => {
//     if (!socket || !isConnected || myOrdersState.orders.length === 0) return;

//     myOrdersState.orders.forEach((o) => {
//       socket.emit("join-order", { orderId: o._id });
//     });

//     return () => {
//       myOrdersState.orders.forEach((o) => {
//         socket.emit("leave-order", { orderId: o._id });
//       });
//     };
//   }, [socket, isConnected, myOrdersState.orders.length]);

//   return {
//     ...myOrdersState,

//     // Actions
//     getMyOrders: () => dispatch(fetchMyOrders()),
//     getMyOrder: (id) => dispatch(fetchMyOrderById(id)),
//     updateMyOrder: (orderId, payload) =>
//       dispatch(updateMyOrder({ orderId, payload })).unwrap(),
//     cancelMyOrder: (orderId, reason) =>
//       dispatch(cancelMyOrder({ orderId, reason })).unwrap(),

//     // Utility
//     clearError: () => dispatch(clearMyOrdersError()),
//     clearSuccess: () => dispatch(clearMyOrdersSuccess()),
//     clearCurrentOrder: () => dispatch(clearCurrentMyOrder()),
//     resetMyOrders: () => dispatch(resetMyOrdersState()),
//   };
// };


// import { useEffect, useCallback } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   fetchMyOrders,
//   fetchMyOrderById,
//   updateMyOrder as updateMyOrderThunk,
//   cancelMyOrder as cancelMyOrderThunk,
//   clearMyOrdersError,
//   clearMyOrdersSuccess,
//   clearCurrentMyOrder,
//   resetMyOrdersState,
//   socketOrderUpsert,
//   socketOrderCancelled,
// } from "../redux/slices/myOrdersSlice";
// import { useSocket } from "../context/SocketContext";
// import { getOrCreateAnonymousId } from "../utils/anonymousId";

// export const useMyOrders = () => {
//   const dispatch = useDispatch();
//   const myOrdersState = useSelector((state) => state.myOrders) || { orders: [] };
//   const { socket, isConnected } = useSocket();

//   // Real-time socket listeners
//   useEffect(() => {
//     if (!socket || !isConnected) return;

//     const handleStatusUpdate = (data) => {
//       dispatch(socketOrderUpsert(data));
//     };

//     const handleOrderUpdated = (data) => {
//       dispatch(socketOrderUpsert(data));
//     };

//     const handleOrderCancelled = (data) => {
//       dispatch(socketOrderCancelled(data));
//     };

//     socket.on("order-status-updated", handleStatusUpdate);
//     socket.on("order-updated", handleOrderUpdated);
//     socket.on("order-cancelled", handleOrderCancelled);

//     return () => {
//       socket.off("order-status-updated", handleStatusUpdate);
//       socket.off("order-updated", handleOrderUpdated);
//       socket.off("order-cancelled", handleOrderCancelled);
//     };
//   }, [socket, isConnected, dispatch]);

//   // Join order rooms for real-time updates
//   useEffect(() => {
//     if (!socket || !isConnected || !myOrdersState.orders || myOrdersState.orders.length === 0) return;

//     myOrdersState.orders.forEach((o) => {
//       const orderId = o._id || o.id;
//       if (orderId) {
//         socket.emit("join-order", { orderId });
//       }
//     });

//     return () => {
//       myOrdersState.orders.forEach((o) => {
//         const orderId = o._id || o.id;
//         if (orderId) {
//           socket.emit("leave-order", { orderId });
//         }
//       });
//     };
//   }, [socket, isConnected, myOrdersState.orders]);

//   // Stable Actions with explicit anonymousId
//   const getMyOrders = useCallback(() => {
//     return dispatch(fetchMyOrders());
//   }, [dispatch]);

//   const getMyOrder = useCallback(
//     (id) => {
//       return dispatch(fetchMyOrderById(id));
//     },
//     [dispatch]
//   );

//   const updateMyOrder = useCallback(
//     (orderId, payload) => {
//       const anonId = getOrCreateAnonymousId();
//       return dispatch(
//         updateMyOrderThunk({
//           orderId,
//           payload: {
//             ...payload,
//             anonymousId: anonId, // ⭐ Order ownership ensure karne ke liye
//           },
//         })
//       ).unwrap();
//     },
//     [dispatch]
//   );

//   const cancelMyOrder = useCallback(
//     (orderId, reason = "") => {
//       return dispatch(cancelMyOrderThunk({ orderId, reason })).unwrap();
//     },
//     [dispatch]
//   );

//   return {
//     ...myOrdersState,

//     // Actions
//     getMyOrders,
//     getMyOrder,
//     updateMyOrder,
//     cancelMyOrder,

//     // Utility
//     clearError: () => dispatch(clearMyOrdersError()),
//     clearSuccess: () => dispatch(clearMyOrdersSuccess()),
//     clearCurrentOrder: () => dispatch(clearCurrentMyOrder()),
//     resetMyOrders: () => dispatch(resetMyOrdersState()),
//   };
// };

import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchMyOrders,
  fetchMyOrderById,
  updateMyOrder as updateMyOrderThunk,
  cancelMyOrder as cancelMyOrderThunk,
  clearMyOrdersError,
  clearMyOrdersSuccess,
  clearCurrentMyOrder,
  resetMyOrdersState,
  socketOrderUpsert,
  socketOrderCancelled,
  PAGE_SIZE,
} from "../redux/slices/myOrdersSlice";
import { useSocket } from "../context/SocketContext";
import { getOrCreateAnonymousId } from "../utils/anonymousId";

export const useMyOrders = () => {
  const dispatch = useDispatch();
  const myOrdersState =
    useSelector((state) => state.myOrders) || { orders: [] };
  const { socket, isConnected } = useSocket();

  // Real-time socket listeners
  useEffect(() => {
    if (!socket || !isConnected) return;

    const handleStatusUpdate = (data) => dispatch(socketOrderUpsert(data));
    const handleOrderUpdated = (data) => dispatch(socketOrderUpsert(data));
    const handleOrderCancelled = (data) =>
      dispatch(socketOrderCancelled(data));

    socket.on("order-status-updated", handleStatusUpdate);
    socket.on("order-updated", handleOrderUpdated);
    socket.on("order-cancelled", handleOrderCancelled);

    return () => {
      socket.off("order-status-updated", handleStatusUpdate);
      socket.off("order-updated", handleOrderUpdated);
      socket.off("order-cancelled", handleOrderCancelled);
    };
  }, [socket, isConnected, dispatch]);

  // Join order rooms
  useEffect(() => {
    if (
      !socket ||
      !isConnected ||
      !myOrdersState.orders ||
      myOrdersState.orders.length === 0
    )
      return;

    myOrdersState.orders.forEach((o) => {
      const orderId = o._id || o.id;
      if (orderId) socket.emit("join-order", { orderId });
    });

    return () => {
      myOrdersState.orders.forEach((o) => {
        const orderId = o._id || o.id;
        if (orderId) socket.emit("leave-order", { orderId });
      });
    };
  }, [socket, isConnected, myOrdersState.orders]);

  // ⭐ Pagination-aware fetch
  const getMyOrders = useCallback(
    (opts = {}) => {
      const { page = 1, limit = PAGE_SIZE, append = false } = opts;
      return dispatch(fetchMyOrders({ page, limit, append }));
    },
    [dispatch]
  );

  const getMyOrder = useCallback(
    (id) => dispatch(fetchMyOrderById(id)),
    [dispatch]
  );

  const updateMyOrder = useCallback(
    (orderId, payload) => {
      const anonId = getOrCreateAnonymousId();
      return dispatch(
        updateMyOrderThunk({
          orderId,
          payload: { ...payload, anonymousId: anonId },
        })
      ).unwrap();
    },
    [dispatch]
  );

  const cancelMyOrder = useCallback(
    (orderId, reason = "") =>
      dispatch(cancelMyOrderThunk({ orderId, reason })).unwrap(),
    [dispatch]
  );

  return {
    ...myOrdersState,

    getMyOrders,
    getMyOrder,
    updateMyOrder,
    cancelMyOrder,

    clearError: () => dispatch(clearMyOrdersError()),
    clearSuccess: () => dispatch(clearMyOrdersSuccess()),
    clearCurrentOrder: () => dispatch(clearCurrentMyOrder()),
    resetMyOrders: () => dispatch(resetMyOrdersState()),
  };
};